<template>
  <div :class="{
    theme_solid: theme_solid,
    isShowMenuPop: show_menu,
    show_scroll_bg: show_scroll_bg,
  }" class="header">
    <div class="flex a_i_c j_c_b" style="
        position: relative;
        z-index: 100;
        width: 100%;
        box-shadow: 0 0 20px 3px rgba(0, 0, 0, 0.1);
      ">
      <div class="flex a_i_c">
        <!-- 首页始终白底 -->
        <div @click="jump_home" v-html="icon.logo" v-if="theme_solid" class="logo pc_logo"></div>
        <!-- 黑底 -->
        <div @click="jump_home" v-html="icon.mobile_logo" v-if="!theme_solid && !show_scroll_bg" class="logo pc_logo">
        </div>
        <!-- 滚动后白底 -->
        <div @click="jump_home" v-html="icon.logo" v-if="!theme_solid && show_scroll_bg" class="logo pc_logo"></div>

        <div @click="jump_home" v-html="icon.mobile_logo" v-if="!show_menu && !show_scroll_bg" class="logo mobile_logo">
        </div>
        <div @click="jump_home" v-html="icon.logo" v-if="!show_menu && show_scroll_bg"
          class="logo mobile_logo show_menu_logo"></div>
        <div @click="jump_home" v-html="icon.logo" v-if="show_menu" class="logo mobile_logo show_menu_logo"></div>
        <!-- nav -->
        <div class="flex a_i_c pc_nav">
          <div :class="{
            active_nav: item.path.indexOf($route.name) != -1,
          }" class="item_nav p_r" v-for="(item, index) in navs" :key="index">
            <div @click="jump_nav_menu(item)" class="text">
              {{ item.name }}
            </div>
            <!-- chilren -->
            <div v-if="item.children.tab.length" class="children_pop flex a_i_s" style="">
              <div style="" v-for="(item_, index_) in item.children.tab" :key="index_">
                <div v-if="item.children.tab.length > 1" class="" style="margin-left: 14px; color: #333">
                  {{ item_.name }}
                </div>
                <!-- list -->
                <div>
                  <div @click="jump_nav(item__)" :class="{
                    active_choose: item__.path == $route.name,
                  }" class="flex a_i_c item_text" v-for="(item__, index__) in item_.list" :key="index__">
                    <svg class="show_icon" style="transform: rotate(-180deg); margin-top: 2px" width="8"
                      viewBox="0 0 11 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M11 0H6.34369L0.961165 5.64444C-0.320388 6.97778 -0.320388 9.15556 0.961165 10.4889L6.25825 16H10.9146L3.8233 8.57778C3.52427 8.26667 3.52427 7.82222 3.8233 7.51111L11 0Z"
                        fill="#1AA858" />
                    </svg>

                    <div style="padding: 0 4px; white-space: nowrap">
                      {{ item__.name }}
                    </div>
                    <svg class="show_icon" style="margin-top: 2px" width="8" viewBox="0 0 11 16" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M11 0H6.34369L0.961165 5.64444C-0.320388 6.97778 -0.320388 9.15556 0.961165 10.4889L6.25825 16H10.9146L3.8233 8.57778C3.52427 8.26667 3.52427 7.82222 3.8233 7.51111L11 0Z"
                        fill="#1AA858" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex a_i_c">
        <div @click="onShow_menu" v-html="icon.menu" v-if="!show_menu" class="menu"></div>
        <div @click="onClose_menu" v-html="icon.show_menu" v-if="show_menu" class="menu show_menu"></div>
        <div v-html="icon.appointment" @click="$store.commit('changeAppointModal', true)" class="appointment"></div>
      </div>
    </div>
    <!-- 移动端弹出菜单 -->
    <div class="popBox_bg" v-if="show_menu"></div>
    <div class="popBox" v-if="show_menu">
      <div :class="{ show_chilren_nav_ofMobile: show_chilren_nav[item.name] }" v-for="(item, index) in navs"
        :key="index">
        <div @click="show_mobile_children(item)" class="flex a_i_c j_c_b item_row">
          <div class="item_row_name" :class="{
            active_nav: item.path.indexOf($route.name) != -1,
          }">
            {{ item.name }}
          </div>
          <svg class="right_icon" width="14" height="14" viewBox="0 0 17 30" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M0.906555 0.765625L14.925 14.7841L0.906555 28.8025" stroke="#C4C4C4" stroke-width="2" />
          </svg>
        </div>
        <!-- children -->
        <div class="chilren_nav_ofMobile">
          <div>
            <div style="padding-right: 20px; margin-top: 10px" v-for="(item_, index_) in item.children.tab"
              :key="index_">
              <div v-if="index_ === 0">
                <div v-if="item.children.tab.length > 1" class="" style="color: black; padding: 10px 0">
                  {{ item_.name }}
                </div>
                <!-- list -->
                <div>
                  <div @click="jump_nav(item__)" :class="{
                    active_choose: item__.path == $route.name,
                  }" class="flex a_i_c item_text" v-for="(item__, index__) in item_.list" :key="index__">
                    <div style="
                        padding: 0 4px;
                        white-space: nowrap;
                        padding: 10px 0;
                        color: #888;
                      ">
                      {{ item__.name }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div style="padding-right: 20px; margin-top: 10px"  v-for="(item_, index_) in item.children.tab"
              :key="index_">
              <div v-if="index_ !== 0">
                <div v-if="item.children.tab.length > 1" class="" style="color: black; padding: 10px 0">
                  {{ item_.name }}
                </div>
                <!-- list -->
                <div>
                  <div @click="jump_nav(item__)" :class="{
                    active_choose: item__.path == $route.name,
                  }" class="flex a_i_c item_text" v-for="(item__, index__) in item_.list" :key="index__">
                    <div style="
                        padding: 0 4px;
                        white-space: nowrap;
                        padding: 10px 0;
                        color: #888;
                      ">
                      {{ item__.name }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showAppointModal" class="appointModal">
      <div class="appointHead">
        <span>联系信息</span>
        <i class="el-icon-close el-icon-style" @click="$store.commit('changeAppointModal', false)"></i>
      </div>
      <div class="appointForm">
        <div class="formItem">
          <div class="formLabel">
            联系信息<span class="requiredSymbol" style="color: red">*</span>
          </div>
          <div class="formContent">
            <input type="text" v-model="appointInfo.phone" placeholder="请输入11位手机号码" />
          </div>
        </div>
        <div class="formItem">
          <div class="formLabel">
            姓名<span class="requiredSymbol" style="color: red">*</span>
          </div>
          <div class="formContent">
            <input type="text" v-model="appointInfo.name" placeholder="请输入您的姓名" />
          </div>
        </div>
        <div class="formItem">
          <div class="formLabel">
            公司名称<span class="requiredSymbol" style="color: red">*</span>
          </div>
          <div class="formContent">
            <input type="text" v-model="appointInfo.company" placeholder="请输入您供职的公司名称" />
          </div>
        </div>
        <div class="formItem">
          <div class="formLabel">邮箱</div>
          <div class="formContent">
            <input type="text" v-model="appointInfo.email" placeholder="请输入您的邮箱" />
          </div>
        </div>
        <div class="formItem">
          <div class="formLabel">留言</div>
          <div class="formContent">
            <textarea rows="5" v-model="appointInfo.remark" placeholder="请在此留言"></textarea>
          </div>
        </div>
        <div class="formItem">
          <div class="submitAppoint" @click="appointSubmit()">提交</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["theme_solid"], //白色实底
  data() {
    return {
      show_chilren_nav: {},
      show_scroll_bg: false, //滚动背景
      show_menu: false, //展开菜单 移动端
      navs: [
        {
          name: "人工智能慢病管理平台",
          path: ["WholeProcessHealth"],
          children: {
            tab: [
              // {
              //   name:'',
              //   list:[
              //     {
              //       name:'全程健康生态社区',
              //       path:'WholeProcessHealth',
              //     },
              //     {
              //       name:'全方位慢病管理体系',
              //       path:''
              //     }
              //   ]
              // }
            ],
          },
        },
        {
          name: "解决方案",
          path: [
            "HealthyManageCore",
            "SlowSickManageCore",
            "HosFollowUp",
            "RegionEdu",
          ],
          children: {
            tab: [
              {
                name: "",
                list: [
                  {
                    name: "健康管理中心",
                    path: "HealthyManageCore",
                  },
                  {
                    name: "慢病管理中心",
                    path: "SlowSickManageCore",
                  },
                  {
                    name: "院内、院外随访",
                    path: "HosFollowUp",
                  },
                  {
                    name: "区域健康宣教",
                    path: "RegionEdu",
                  },
                ],
              },
            ],
          },
        },
        {
          name: "产品与服务",
          path: [
            "SmartChronicDisease",
            "IntelligentPhysical",
            "SmartFollowup",
            "SatisfactionSurvey",
            "SmartEducation",
            "IntelligentMonitoring",
            "SmartFamilyDoc",
            "SmartWeapp",
            "SmartDecision",
            "SmartInspection",
            "SmartLibrary",
          ],
          children: {
            tab: [
              {
                name: "华医生 人工智能慢病管理",
                list: [
                  {
                    name: "人工智能慢病管理平台",
                    path: "SmartChronicDisease",
                  },

                  {
                    name: "人工智能随访管理平台",
                    path: "SmartFollowup",
                  },

                  {
                    name: "人工智能宣教管理平台",
                    path: "SmartEducation",
                  },
                  {
                    name: "智慧检后管理与体检系统",
                    path: "IntelligentPhysical",
                  },
                  {
                    name: "智能监测设备",
                    path: "IntelligentMonitoring",
                  },
                  {
                    name: "AI医患语音互动服务平台",
                    path: "SmartFamilyDoc",
                  },
                  // {
                  //   name: "智慧慢病医患小程序",
                  //   path: "SmartWeapp",
                  // },
                  // {
                  //   name: "智慧导检系统",
                  //   path: "SmartInspection",
                  // },
                ],
              },
              {
                name: "华医生 慢病管理智能体",
                list: [
                  {
                    name: "华医生·慢病失访预警智能体",
                    // path: "SmartLibrary",
                  },
                  { name: "华医生·慢病患者分层智能体" },
                  { name: "华医生·随访计划规划智能体" },
                  { name: "华医生·随访结构化智能体" },
                  { name: "华医生·慢病用药审核智能体" },
                  { name: "华医生·骨科术后康复智能体" },
                  { name: "华医生·慢病科研数据智能体" },
                  { name: "华医生·随访数据质检智能体" },
                  { name: "华医生·患者随访沟通智能体" },
                  { name: "华医生·慢病患者教育智能体" },
                  { name: "华医生·多科室患者画像智能体" },
                  { name: "华医生·孕期风险管理智能体" },
                  { name: "华医生·多病共管协调智能体" },
                  { name: "华医生·科室运营洞察智能体" },
                ],
              },
              {
                name: "华医生 慢病管理运营服务",
                list: [
                  {
                    name: "全程满意度调查",
                    path: "SatisfactionSurvey",
                  },
                  {
                    name: "健康、慢病管理服务（驻场）",
                    path: "SmartDecision",
                  },
                ],
              },
            ],
          },
        },
        // {
        //   name: "智慧地带",
        //   path: "",
        //   children: {
        //     tab: [
        //       {
        //         name: "",
        //         list: [
        //           {
        //             name: "案例名称",
        //             path: "",
        //           },
        //           {
        //             name: "合作伙伴",
        //             path: "",
        //           },
        //         ],
        //       },
        //     ],
        //   },
        // },
        {
          name: "生态招募",
          path: ["EcologicalRecruitment"],
          children: {
            tab: [
              // {
              //   name:'',
              //   list:[
              //     {
              //       name:'招募方向',
              //       path:'EcologicalRecruitment',
              //     },
              //     {
              //       name:'合作共赢',
              //       path:''
              //     }
              //   ]
              // }
            ],
          },
        },
        {
          name: "关于我们",
          path: ["AboutUs", "Recruit"],
          children: {
            tab: [
              {
                name: "",
                list: [
                  {
                    name: "公司介绍",
                    path: "AboutUs",
                  },
                  {
                    name: "招贤纳士",
                    path: "Recruit",
                  },
                ],
              },
            ],
          },
        },
        {
          name: "新闻中心",
          path: ["NewsCenter"],
          children: {
            tab: [],
          },
        },
      ],
      icon: {
        appointment: `<svg style="width:100%;height:100%;" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="120" height="120" fill="#1AA858"/>
      <path d="M56.1362 23.7303H63.8588V26.3379H56.1362V23.7303ZM67.7452 21C68.4299 21 68.9836 21.5624 68.9836 22.2629V27.6468C68.9836 28.3473 68.4299 28.9097 67.7452 28.9097C67.0606 28.9097 66.5068 28.3473 66.5068 27.6468V22.2629C66.5017 21.5675 67.0606 21 67.7452 21ZM52.29 21C52.9747 21 53.5285 21.5624 53.5285 22.2629V27.6468C53.5285 28.3473 52.9747 28.9097 52.29 28.9097C51.6054 28.9097 51.0113 28.3473 51.0113 27.6468V22.2629C51.0113 21.5675 51.6054 21 52.29 21ZM58.8044 46.4267C58.1902 47.0403 57.2135 47.0403 56.5994 46.4267L51.4644 41.2371C50.8603 40.6337 50.8553 39.6418 51.4493 39.0283L51.4644 39.0129C52.0736 38.3994 53.0552 38.3994 53.6694 39.0129L57.7069 43.0879L66.1494 34.5698C66.7585 33.9562 67.7402 33.9562 68.3493 34.5698C68.9534 35.1731 68.9585 36.165 68.3644 36.7786L68.3493 36.7939L58.8044 46.4267ZM71.6317 23.715C75.1556 24.3183 78 27.4372 78 31.1952V50.1131C78 54.3006 74.6673 57.6956 70.5543 57.6956H49.4457C45.3327 57.7008 42 54.3058 42 50.1131V31.1952C42 27.4934 44.8645 24.3285 48.4489 23.7099V26.297C46.3043 26.8594 44.5675 28.8382 44.5675 31.1952V50.0364C44.5675 52.8281 46.7926 55.0931 49.5313 55.0931H70.509C73.2527 55.0931 75.4728 52.8281 75.4728 50.0364V31.1952C75.4728 28.8893 73.8216 26.8748 71.6317 26.297V23.715Z" fill="white"/>
      <path d="M29.24 80.5972H39.08V81.9572H35.02C34.9267 82.6505 34.7933 83.3972 34.62 84.1972H38.4V93.6172H37.04V85.4772H31.26V93.6172H29.9V84.1972H33.24C33.4 83.4905 33.52 82.7439 33.6 81.9572H29.24V80.5972ZM35.56 93.6172C37.04 94.7772 38.28 95.9372 39.28 97.0972L38.28 98.0972C37.4 96.9772 36.1867 95.7839 34.64 94.5172L35.56 93.6172ZM33.4 86.6172H34.8V90.2172C34.7467 92.3505 34.2667 94.0505 33.36 95.3172C32.48 96.4905 31.0533 97.4172 29.08 98.0972L28.3 96.8772C30.22 96.2505 31.5533 95.4239 32.3 94.3972C32.9933 93.2905 33.36 91.8972 33.4 90.2172V86.6172ZM23.02 83.1172C23.62 83.6905 24.1133 84.1905 24.5 84.6172C25.2067 83.8439 25.8667 82.9505 26.48 81.9372H21.44V80.5972H28.02V81.7372C27.22 83.1772 26.3267 84.4439 25.34 85.5372C25.6467 85.8972 25.9733 86.2972 26.32 86.7372H28.6V87.6172C28.2933 89.1372 27.9067 90.3572 27.44 91.2772L26.26 90.8172C26.66 89.9772 26.9867 89.0639 27.24 88.0772H25.12V96.4372C25.12 97.4905 24.6133 98.0172 23.6 98.0172H21.68L21.4 96.7172C22.0667 96.7839 22.6467 96.8172 23.14 96.8172C23.5533 96.8172 23.76 96.5772 23.76 96.0972V88.0772H20.88V86.7372H24.76C23.9467 85.7772 23.0133 84.7905 21.96 83.7772L23.02 83.1172ZM51.26 87.9172C52.6867 89.5839 53.8133 91.0905 54.64 92.4372L53.42 93.2972C52.6467 91.9372 51.5333 90.3905 50.08 88.6572L51.26 87.9172ZM53 79.9172C52.7733 80.9439 52.4667 81.9772 52.08 83.0172H58.34C58.34 89.9105 58.24 94.1705 58.04 95.7972C57.8133 97.3039 56.8067 98.0572 55.02 98.0572L52.62 97.9772L52.26 96.6372C53.5933 96.6905 54.4467 96.7172 54.82 96.7172C55.9 96.7172 56.52 96.2172 56.68 95.2172C56.8 94.0572 56.88 90.4772 56.92 84.4772H51.46C50.74 85.9305 49.8933 87.1972 48.92 88.2772L48.02 87.0972C49.7533 85.0972 50.9333 82.6439 51.56 79.7372L53 79.9172ZM48.4 95.6172C46.36 96.2972 43.9867 96.8639 41.28 97.3172L41.1 95.8972C43.8067 95.4705 46.24 94.8839 48.4 94.1372V95.6172ZM45.76 80.2772C44.7867 82.8105 43.7933 84.8705 42.78 86.4572C43.6333 86.3505 44.56 86.1972 45.56 85.9972L46.88 83.5172L48.26 84.0372C46.3667 87.5172 44.76 90.0172 43.44 91.5372C44.9733 91.2572 46.5467 90.8639 48.16 90.3572V91.6372C46 92.3305 43.8467 92.8239 41.7 93.1172L41.32 91.7772C41.5867 91.6572 41.8067 91.5172 41.98 91.3572C42.78 90.5305 43.72 89.1972 44.8 87.3572L41.42 87.9172L41.06 86.5772C41.2733 86.4839 41.48 86.2972 41.68 86.0172C42.72 84.1505 43.6133 82.0505 44.36 79.7172L45.76 80.2772ZM63.22 87.3372C62.62 88.2039 61.9467 89.0639 61.2 89.9172L60.78 88.4772C62.86 85.9172 64.36 82.9905 65.28 79.6972L66.58 80.2972C66.0467 82.0039 65.4 83.5772 64.64 85.0172V98.1372H63.22V87.3372ZM66.24 83.1972H71.54V79.7572H72.96V83.1972H78.42V84.5972H74.2C75.1467 87.9305 76.8133 90.8705 79.2 93.4172L78.26 94.5972C75.8067 91.6239 74.1067 88.2905 73.16 84.5972H72.96V92.6172H76.06V93.9972H72.96V98.1172H71.54V93.9972H68.48V92.6172H71.54V84.5972H71.32C70.3067 88.7572 68.5667 92.1572 66.1 94.7972L65.36 93.5772C67.64 91.2572 69.28 88.2639 70.28 84.5972H66.24V83.1972ZM90.66 85.6572C89.9267 86.4839 89.1667 87.1972 88.38 87.7972L87.62 86.6372C89.8867 84.8772 91.6133 82.6172 92.8 79.8572H94.12C95.1067 82.3772 96.8533 84.6105 99.36 86.5572L98.58 87.7572C97.74 87.1172 96.9733 86.4172 96.28 85.6572V86.8972H90.66V85.6572ZM96.22 85.5772C95.06 84.2572 94.14 82.8172 93.46 81.2572C92.6467 82.9772 91.7333 84.4172 90.72 85.5772H96.22ZM88.2 96.0372H94.7C95.46 93.9305 96.14 91.2972 96.74 88.1372L98.12 88.4772C97.5467 91.3972 96.8733 93.9172 96.1 96.0372H99.12V97.4172H88.2V96.0372ZM90.04 88.7172C90.64 90.2772 91.2133 92.1905 91.76 94.4572L90.52 94.7572C90.0933 92.8639 89.52 90.9905 88.8 89.1372L90.04 88.7172ZM93.12 88.1372C93.64 89.6705 94.1267 91.4905 94.58 93.5972L93.32 93.8972C92.96 92.0172 92.48 90.2239 91.88 88.5172L93.12 88.1372ZM85.96 82.0172H81.12V80.6972H87.4L86.44 88.9372H87.68C87.68 93.4839 87.4867 96.1105 87.1 96.8172C86.6867 97.5105 85.86 97.8572 84.62 97.8572C84.1533 97.8572 83.68 97.8372 83.2 97.7972L82.82 96.5172C83.5267 96.5972 84.02 96.6372 84.3 96.6372C85.26 96.6372 85.84 96.3305 86.04 95.7172C86.2533 95.0372 86.36 93.2039 86.36 90.2172H81.26L82.2 83.3572L83.52 83.4372L82.72 88.9372H85.08L85.96 82.0172ZM85.22 93.2972C83.9267 93.7905 82.44 94.1972 80.76 94.5172L80.58 93.1572C82.3933 92.8505 83.94 92.4639 85.22 91.9972V93.2972Z" fill="white"/>
      </svg>
      `,
        show_menu: `<svg style="width:100%;height:100%;" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="40.3037" height="3.50467" transform="matrix(0.707106 0.707107 -0.707106 0.707107 4.49066 1.26953)" fill="#1AA858"/>
        <rect x="0.985962" y="29.3086" width="40.3038" height="3.50467" transform="rotate(-45 0.985962 29.3086)" fill="#1AA858"/>
        </svg>
        `,
        menu: `<svg style="width:100%;height:100%" viewBox="0 0 40 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="40" height="3" fill="#1AA858"/>
        <rect y="11" width="40" height="3" fill="#1AA858"/>
        <rect y="22" width="40" height="3" fill="#1AA858"/>
        </svg>
        `,
        mobile_logo: `<svg style="width:100%;height:100%" viewBox="0 0 238 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M24.6132 0H20.3038V29.8343H26.4364V1.8232C26.4364 0.828729 25.6077 0 24.6132 0Z" fill="white"/>
        <path d="M4.30939 0H0V29.8343H6.1326V1.8232C6.1326 0.828729 5.30387 0 4.30939 0Z" fill="white"/>
        <path d="M24.0063 18.0213V11.8887L2.54226 11.8887V18.0213L24.0063 18.0213Z" fill="white"/>
        <path d="M39.1989 0H30.1658L41.0221 10.8564C42.2652 12.0994 44.1713 12.0994 45.4144 10.8564L47.7348 8.53591L39.1989 0Z" fill="#45AD5C"/>
        <path d="M30.4144 29.8339H39.4476L47.7349 21.4637L45.4144 19.1433C44.1713 17.9002 42.2653 17.9002 41.0222 19.1433L30.4144 29.8339Z" fill="#45AD5C"/>
        <path d="M69.116 0H60.0829L49.6409 10.5249C47.1547 13.011 47.1547 17.0718 49.6409 19.558L59.9171 29.8343H68.9503L55.1934 15.9945C54.6133 15.4144 54.6133 14.5856 55.1934 14.0055L69.116 0Z" fill="white"/>
        <path d="M77.9834 9.86133H71.8508V29.9166H77.9834V9.86133Z" fill="white"/>
        <path d="M111.63 0.0820312H107.32V29.9163H113.453V1.90524C113.453 0.910761 112.624 0.0820312 111.63 0.0820312Z" fill="white"/>
        <path d="M80.8839 9.86133V29.9166H87.0165V15.9939H92.2375C95.5524 15.9939 98.2872 18.6459 98.2872 22.0436V29.9995H104.42V20.0547C104.42 14.4193 99.8618 9.86133 94.2265 9.86133H80.8839V9.86133Z" fill="white"/>
        <path d="M76.1602 0.0820312H71.8508V6.21463H77.9834V1.90524C77.9834 0.910761 77.1547 0.0820312 76.1602 0.0820312Z" fill="white"/>
        <path d="M130.856 9.86133H122.983L115.773 17.0713C114.199 18.6459 114.199 21.2149 115.773 22.8724L122.818 29.9166H130.691L121.575 20.7177C121.16 20.3033 121.16 19.6403 121.575 19.226L130.856 9.86133Z" fill="white"/>
        <path d="M144.206 13.2715H142.15V22.0565H144.206V13.2715Z" fill="white"/>
        <path d="M161.308 21.4953H153.271C151.869 21.4953 150.654 20.3738 150.654 18.8785V10H152.71V18.8785C152.71 19.1589 152.897 19.3458 153.178 19.3458H161.215V21.4953H161.308Z" fill="white"/>
        <path d="M145.981 16.9159L145.607 14.8598L158.785 12.1495C158.878 12.1495 159.065 11.9626 159.065 11.8692V10H161.121V11.8692C161.121 12.9907 160.28 14.0187 159.252 14.2056L145.981 16.9159Z" fill="white"/>
        <path d="M161.308 23.832H140V25.8881H161.308V23.832Z" fill="white"/>
        <path d="M151.682 21.6816H149.626V29.9994H151.682V21.6816Z" fill="white"/>
        <path d="M143.551 10C143.177 11.9626 141.869 13.5514 140.093 14.2991V16.5421C142.991 15.6075 145.234 13.0841 145.701 10H143.551Z" fill="white"/>
        <path d="M212.243 10H191.121V12.0561H212.243V10Z" fill="white"/>
        <path d="M209.813 24.0186H195.607C194.673 24.0186 193.832 23.6448 193.178 22.9905C192.523 22.3363 192.243 21.4018 192.336 20.4672L193.084 11.2148L195.14 11.4018L194.392 20.6541C194.392 21.0279 194.486 21.3083 194.673 21.5887C194.86 21.8691 195.234 21.9625 195.514 21.9625H209.72V24.0186H209.813Z" fill="white"/>
        <path d="M212.243 27.9434H191.121V29.9994H212.243V27.9434Z" fill="white"/>
        <path d="M210.28 28.878L208.224 28.691L208.972 19.4387C208.972 19.0649 208.878 18.7845 208.691 18.5041C208.505 18.2238 208.131 18.1303 207.85 18.1303H193.645V16.0742H207.85C208.785 16.0742 209.626 16.4481 210.28 17.1023C210.934 17.7565 211.215 18.691 211.121 19.5322L210.28 28.878Z" fill="white"/>
        <path d="M230.093 10H228.037V12.8972H230.093V10Z" fill="white"/>
        <path d="M235.888 10H233.832V12.8972H235.888V10Z" fill="white"/>
        <path d="M226.262 10H216.262V12.0561H226.262V10Z" fill="white"/>
        <path d="M219.159 11.3086H217.103V26.1684H219.159V11.3086Z" fill="white"/>
        <path d="M225.14 11.3086H223.084V30.0002H225.14V11.3086Z" fill="white"/>
        <path d="M224.019 15.5137H218.131V17.5697H224.019V15.5137Z" fill="white"/>
        <path d="M224.019 20.5605H218.131V22.6166H224.019V20.5605Z" fill="white"/>
        <path d="M226.262 25.5137H216.262V27.5697H226.262V25.5137Z" fill="white"/>
        <path d="M237.664 12.7109H226.262V14.767H237.664V12.7109Z" fill="white"/>
        <path d="M237.664 18.9727H226.262V21.0287H237.664V18.9727Z" fill="white"/>
        <path d="M230.935 13.9258V19.6267C230.935 22.7108 229.159 26.9164 226.262 27.851V30.0005C230.28 29.1594 232.991 24.1127 232.991 19.6267V13.9258H230.935Z" fill="white"/>
        <path d="M232.991 13.9258V19.6267C232.991 22.7108 234.766 26.9164 237.664 27.851V30.0005C233.645 29.1594 230.935 24.1127 230.935 19.6267V13.9258H232.991Z" fill="white"/>
        <path d="M169.813 13.6445H167.757V29.9997H169.813V13.6445Z" fill="white"/>
        <path d="M187.103 11.3086H171.682V13.3647H187.103V11.3086Z" fill="white"/>
        <path d="M186.729 15.0469H172.056V17.1029H186.729V15.0469Z" fill="white"/>
        <path d="M187.103 18.7852H171.682V20.8412H187.103V18.7852Z" fill="white"/>
        <path d="M184.766 29.9995H173.925C172.804 29.9995 171.869 29.0649 171.869 27.9434V24.392C171.869 23.2705 172.804 22.3359 173.925 22.3359H184.766C185.888 22.3359 186.822 23.2705 186.822 24.392V27.9434C186.822 29.0649 185.888 29.9995 184.766 29.9995ZM184.673 24.392H173.832V27.9434H184.579V24.392H184.673Z" fill="white"/>
        <path d="M180.28 10H178.224V11.8692H180.28V10Z" fill="white"/>
        <path d="M171.308 10H169.159C168.411 12.7103 167.009 15.2336 165.327 17.2897V20.3738C168.131 17.5701 170.28 14.0187 171.308 10Z" fill="white"/>
        </svg>

        `,
        logo: `<svg style="width:100%;height:100%" viewBox="0 0 238 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M24.6132 0H20.3038V29.8343H26.4364V1.8232C26.4364 0.828729 25.6077 0 24.6132 0Z" fill="#21252E"/>
        <path d="M4.30939 0H0V29.8343H6.1326V1.8232C6.1326 0.828729 5.30387 0 4.30939 0Z" fill="#21252E"/>
        <path d="M24.0063 18.0213V11.8887L2.54226 11.8887V18.0213L24.0063 18.0213Z" fill="#21252E"/>
        <path d="M39.1989 0H30.1658L41.0221 10.8564C42.2652 12.0994 44.1713 12.0994 45.4144 10.8564L47.7348 8.53591L39.1989 0Z" fill="#45AD5C"/>
        <path d="M30.4144 29.8339H39.4476L47.7349 21.4637L45.4144 19.1433C44.1713 17.9002 42.2653 17.9002 41.0222 19.1433L30.4144 29.8339Z" fill="#45AD5C"/>
        <path d="M69.116 0H60.0829L49.6409 10.5249C47.1547 13.011 47.1547 17.0718 49.6409 19.558L59.9171 29.8343H68.9503L55.1934 15.9945C54.6133 15.4144 54.6133 14.5856 55.1934 14.0055L69.116 0Z" fill="#21252E"/>
        <path d="M77.9834 9.86133H71.8508V29.9166H77.9834V9.86133Z" fill="#21252E"/>
        <path d="M111.63 0.0820312H107.32V29.9163H113.453V1.90524C113.453 0.910761 112.624 0.0820312 111.63 0.0820312Z" fill="#21252E"/>
        <path d="M80.8839 9.86133V29.9166H87.0165V15.9939H92.2375C95.5524 15.9939 98.2872 18.6459 98.2872 22.0436V29.9995H104.42V20.0547C104.42 14.4193 99.8618 9.86133 94.2265 9.86133H80.8839V9.86133Z" fill="#21252E"/>
        <path d="M76.1602 0.0820312H71.8508V6.21463H77.9834V1.90524C77.9834 0.910761 77.1547 0.0820312 76.1602 0.0820312Z" fill="#21252E"/>
        <path d="M130.856 9.86133H122.983L115.773 17.0713C114.199 18.6459 114.199 21.2149 115.773 22.8724L122.818 29.9166H130.691L121.575 20.7177C121.16 20.3033 121.16 19.6403 121.575 19.226L130.856 9.86133Z" fill="#21252E"/>
        <path d="M144.206 13.2715H142.15V22.0565H144.206V13.2715Z" fill="#21252E"/>
        <path d="M161.308 21.4953H153.271C151.869 21.4953 150.654 20.3738 150.654 18.8785V10H152.71V18.8785C152.71 19.1589 152.897 19.3458 153.178 19.3458H161.215V21.4953H161.308Z" fill="#21252E"/>
        <path d="M145.981 16.9159L145.607 14.8598L158.785 12.1495C158.878 12.1495 159.065 11.9626 159.065 11.8692V10H161.121V11.8692C161.121 12.9907 160.28 14.0187 159.252 14.2056L145.981 16.9159Z" fill="#21252E"/>
        <path d="M161.308 23.832H140V25.8881H161.308V23.832Z" fill="#21252E"/>
        <path d="M151.682 21.6816H149.626V29.9994H151.682V21.6816Z" fill="#21252E"/>
        <path d="M143.551 10C143.177 11.9626 141.869 13.5514 140.093 14.2991V16.5421C142.991 15.6075 145.234 13.0841 145.701 10H143.551Z" fill="#21252E"/>
        <path d="M212.243 10H191.121V12.0561H212.243V10Z" fill="#21252E"/>
        <path d="M209.813 24.0186H195.607C194.673 24.0186 193.832 23.6448 193.178 22.9905C192.523 22.3363 192.243 21.4018 192.336 20.4672L193.084 11.2148L195.14 11.4018L194.392 20.6541C194.392 21.0279 194.486 21.3083 194.673 21.5887C194.86 21.8691 195.234 21.9625 195.514 21.9625H209.72V24.0186H209.813Z" fill="#21252E"/>
        <path d="M212.243 27.9434H191.121V29.9994H212.243V27.9434Z" fill="#21252E"/>
        <path d="M210.28 28.878L208.224 28.691L208.972 19.4387C208.972 19.0649 208.878 18.7845 208.691 18.5041C208.505 18.2238 208.131 18.1303 207.85 18.1303H193.645V16.0742H207.85C208.785 16.0742 209.626 16.4481 210.28 17.1023C210.934 17.7565 211.215 18.691 211.121 19.5322L210.28 28.878Z" fill="#21252E"/>
        <path d="M230.093 10H228.037V12.8972H230.093V10Z" fill="#21252E"/>
        <path d="M235.888 10H233.832V12.8972H235.888V10Z" fill="#21252E"/>
        <path d="M226.262 10H216.262V12.0561H226.262V10Z" fill="#21252E"/>
        <path d="M219.159 11.3086H217.103V26.1684H219.159V11.3086Z" fill="#21252E"/>
        <path d="M225.14 11.3086H223.084V30.0002H225.14V11.3086Z" fill="#21252E"/>
        <path d="M224.019 15.5137H218.131V17.5697H224.019V15.5137Z" fill="#21252E"/>
        <path d="M224.019 20.5605H218.131V22.6166H224.019V20.5605Z" fill="#21252E"/>
        <path d="M226.262 25.5137H216.262V27.5697H226.262V25.5137Z" fill="#21252E"/>
        <path d="M237.664 12.7109H226.262V14.767H237.664V12.7109Z" fill="#21252E"/>
        <path d="M237.664 18.9727H226.262V21.0287H237.664V18.9727Z" fill="#21252E"/>
        <path d="M230.935 13.9258V19.6267C230.935 22.7108 229.159 26.9164 226.262 27.851V30.0005C230.28 29.1594 232.991 24.1127 232.991 19.6267V13.9258H230.935Z" fill="#21252E"/>
        <path d="M232.991 13.9258V19.6267C232.991 22.7108 234.766 26.9164 237.664 27.851V30.0005C233.645 29.1594 230.935 24.1127 230.935 19.6267V13.9258H232.991Z" fill="#21252E"/>
        <path d="M169.813 13.6445H167.757V29.9997H169.813V13.6445Z" fill="#21252E"/>
        <path d="M187.103 11.3086H171.682V13.3647H187.103V11.3086Z" fill="#21252E"/>
        <path d="M186.729 15.0469H172.056V17.1029H186.729V15.0469Z" fill="#21252E"/>
        <path d="M187.103 18.7852H171.682V20.8412H187.103V18.7852Z" fill="#21252E"/>
        <path d="M184.766 29.9995H173.925C172.804 29.9995 171.869 29.0649 171.869 27.9434V24.392C171.869 23.2705 172.804 22.3359 173.925 22.3359H184.766C185.888 22.3359 186.822 23.2705 186.822 24.392V27.9434C186.822 29.0649 185.888 29.9995 184.766 29.9995ZM184.673 24.392H173.832V27.9434H184.579V24.392H184.673Z" fill="#21252E"/>
        <path d="M180.28 10H178.224V11.8692H180.28V10Z" fill="#21252E"/>
        <path d="M171.308 10H169.159C168.411 12.7103 167.009 15.2336 165.327 17.2897V20.3738C168.131 17.5701 170.28 14.0187 171.308 10Z" fill="#21252E"/>
        </svg>

        `,
      },
      // showAppointModal: false,
      appointInfo: {
        name: "",
        phone: "",
        company: "",
        email: "",
        remark: "",
      },
    };
  },
  computed: {
    showAppointModal() {
      return this.$store.state.showAppointModal;
    },
  },
  mounted() {
    let that = this;
    // console.log("header init");
    document.getElementById("app").addEventListener("scroll", function (e) {
      console.log(e.target.scrollTop);
      if (e.target.scrollTop > 80) {
        that.setScrollBg(true);
      } else {
        that.setScrollBg(false);
      }
    });
  },
  methods: {
    jump_nav_menu(item) {
      if (item.children.tab.length == 0) {
        this.$router.push({
          path: "/" + item.path[0],
        });
      }
    },
    show_mobile_children(item) {
      if (item.children.tab.length == 0) {
        this.$router.push({
          path: "/" + item.path[0],
        });
        return;
      }
      this.show_chilren_nav[item.name] = !this.show_chilren_nav[item.name];
      this.$forceUpdate();
    },
    jump_nav(item) {
      if (!item.path) {
        return;
      }
      this.$router.push({
        path: "/" + item.path,
      });
    },
    jump_home() {
      this.$router.push({
        path: "/",
      });
    },
    setScrollBg(type) {
      this.show_scroll_bg = type;
    },
    onShow_menu() {
      this.show_menu = true;
    },
    onClose_menu() {
      this.show_menu = false;
    },
    appointSubmit() {
      const _this = this;
      if (
        this.appointInfo.name &&
        this.appointInfo.phone &&
        this.appointInfo.company
      ) {
        $.ajax({
          type: "POST",
          url: "/server/experience/addExperience",
          data: this.appointInfo,
          success: function (msg) {
            _this.$message(msg);
            _this.$store.commit("changeAppointModal", false);
          },
        });
      } else {
        this.$message({
          message: "请将联系信息填写完整",
          type: "warning",
        });
      }
    },
  },
};
</script>

<style scoped>
.right_icon {
  transition: all 0.4s;
}

.show_chilren_nav_ofMobile .right_icon {
  transform: rotate(90deg);
}

.chilren_nav_ofMobile {
  /* display: none; */
  height: 0 !important;
  overflow: hidden;
  font-size: 14px;
  line-height: 100%;
}

.chilren_nav_ofMobile>div {
  min-width: 50%;
}

.show_chilren_nav_ofMobile .chilren_nav_ofMobile {
  display: flex;
  height: auto !important;
}

.active_nav {
  color: #1aa858;
}

.active_nav .text {
  color: #1aa858;
}

.active_nav::after {
  content: "";
  width: calc(100% - 40px);
  bottom: 2px;
  height: 3px;
  background: #1aa858;
  position: absolute;
  left: 20px;
}

.popBox .active_nav::after {
  display: none;
  background: transparent !important;
}

.children_pop {
  border-radius: 6px;
  background-color: rgb(255, 255, 255);
  padding: 30px;
  position: absolute;
  top: 98%;
  left: 50%;
  transform: translateX(-50%);
  /* border: 1px solid #ccc; */
}

@keyframes header {
  0% {
    transform: translateY(-80px);
  }

  100% {
    transform: translateY(0);
  }
}

.header {
  animation: header 1s ease;
  transition: background 0.4s ease;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100vw;
  height: 80px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  margin: 0 40px;
  cursor: pointer;
}

.show_menu_logo {
  display: none;
}

.theme_solid {
  background: rgb(255, 255, 255);
}

.theme_solid .item_nav {
  color: #333;
}

.item_nav {
  padding: 0 20px;
  font-size: 16px;
  color: #fff;
  white-space: nowrap;
  cursor: pointer;
  line-height: 80px;
}

.item_text:hover {
  color: #1aa858;
}

.children_pop {
  display: none;
  color: #000;
  line-height: 200%;
  font-size: 14px;
  color: #888;
  box-shadow: 0px 0px 10px 0px rgb(202, 202, 202);
  opacity: 0.95;
}

@keyframes show_children_pop {
  0% {
    opacity: 0;
    /* transform: translateX(-50%) scale(0.5); */
    /* transform-origin: center; */
  }

  /* 20% {
    opacity: 1;
  } */
  100% {
    opacity: 0.95;
    /* transform: translateX(-50%); */
  }
}

.item_nav:hover .children_pop {
  cursor: pointer;
  display: flex;
  animation: show_children_pop ease 0.5s;
}

.item_nav:hover {
  color: #1aa858;
}

.item_nav:hover::after {
  content: "";
  width: calc(100% - 40px);
  bottom: 2px;
  height: 3px;
  background: #1aa858;
  position: absolute;
  left: 20px;
}

.show_icon {
  opacity: 0;
}

.active_choose .show_icon {
  opacity: 1;
}

.active_choose {
  color: #1aa858 !important;
}

.active_choose div {
  color: #1aa858 !important;
}

.mobile_logo {
  display: none;
}

.appointment {
  width: 80px;
  height: 80px;
  cursor: pointer;
}

.menu {
  display: none;
}

.pc_logo {
  /* width: 100%; */
  height: 41px;
}

.pc_logo>>>svg {
  width: 75% !important;
}

@keyframes show_popBox {
  0% {
    transform: translateX(-100vw);
  }

  100% {
    transform: none;
  }
}

.popBox_bg {
  position: absolute;
  top: 100%;
  left: 0;
  background: #fff;
  z-index: 9;
  width: 100%;
  height: calc(100vh - 80px);
  overflow-y: auto;
  animation: show_popBox 1s ease forwards;
}

.popBox {
  width: 100%;
  position: absolute;
  left: 0;
  top: 100%;
  background: #fff;
  z-index: 10;
  min-height: calc(100vh - 70px);
  box-sizing: border-box;
  padding: 20px;
  animation: show_popBox 0.6s cubic-bezier(0.55, 0.66, 0.07, 1.2) forwards;
  height: calc(100vh - 80px);
  overflow-y: auto;
}

@keyframes item_row {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.item_row {
  width: 100%;
  padding: 12px 0;
  line-height: 100%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  animation: item_row 2s ease;
}

.item_row_name {
  font-size: 14px;
}

.show_scroll_bg {
  background: #fff !important;
}

.show_scroll_bg .item_nav {
  color: #000 !important;
}

.appointModal {
  width: 380px;
  height: 580px;
  border-radius: 4px;
  position: fixed;
  background-color: #fff;
  right: 50px;
  top: 100px;
  font-size: 14px;
}

.appointModal .appointHead {
  width: 348px;
  height: 40px;
  background-color: #1aa858;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  border-radius: 4px 4px 0 0;
}

.appointModal .appointForm {
  padding: 2px 16px 0 16px;
}

.appointModal .formItem {
  margin-top: 22px;
}

.appointModal .formLabel {
  color: #21252e;
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.appointModal .formContent input,
.appointModal .formContent textarea {
  border: 1px solid #c4c4c4;
  width: 100%;
  cursor: pointer;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  outline: none;
  padding: 0 10px;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 100%;
}

input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #c4c4c4;
}

textarea {
  padding-top: 5px !important;
  font-family: PingFang SC, Helvetica, Arial, sans-serif;
}

.appointModal .formContent input {
  height: 32px;
  line-height: 32px;
}

.submitAppoint {
  width: 100%;
  height: 32px;
  background-color: #1aa858;
  color: #fff;
  border-radius: 4px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  cursor: pointer;
}

.appointModal .requiredSymbol {
  color: red;
  margin-left: 5px;
}

@media screen and (max-width: 1024px) {
  .appointModal {
    width: 6.5rem !important;
    overflow: hidden;
    height: auto !important;
    overflow-y: auto;
    padding-bottom: 20px;
    box-shadow: 0 0 20px 3px rgba(0, 0, 0, 0.1);
  }

  .appointModal .formLabel {
    margin-bottom: 0.04rem;
  }

  .appointModal .formItem {
    margin-top: 0.22rem;
  }

  .appointHead {
    width: 100% !important;
    box-sizing: border-box;
  }

  .header {
    background: rgba(0, 0, 0, 0) !important;
    height: 70px;
  }

  .pc_nav {
    display: none;
  }

  .pc_logo {
    display: none;
  }

  .mobile_logo {
    display: inline-block;
    height: 70px;
    width: auto;
    max-width: 330px;
    overflow: hidden;
  }

  .logo {
    margin: 0 14px;
  }

  .menu {
    width: 23px;
    margin: 0 20px;
    display: inline-block;
  }

  .appointment {
    display: inline-block;
    width: 70px;
    height: 70px;
  }

  .isShowMenuPop {
    background: #fff !important;
  }

  .isShowMenuPop .item_nav {
    color: #333;
  }

  .show_menu_logo {
    display: inline-block;
  }

  .show_scroll_bg {
    background: #fff !important;
  }

  .chilren_nav_ofMobile {
    display: flex;
  }

  .show_chilren_nav_ofMobile {
    height: auto !important;
  }

  .appointModal {
    width: 3.8rem;
    height: 5.8rem;
    position: fixed;
    background-color: #fff;
    right: 0.5rem;
    top: 2rem;
  }
  .popBox {
  padding: 20px 16px;
}
}
</style>
